/* tslint:disable */
/* eslint-disable */
export enum ApplicationType {
  Atao = 'ATAO',
  Hospi = 'HOSPI'
}
